// TODO - Use ValidationList or ExclusionList instead, however at JSX list.item is not supported

import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import { ValidationListProps } from '@qbe/ads-blocks-forms';
import { Box, Icon, Typography, useTheme } from '@qbe/ads-core';
import React from 'react';

type ListItem = {
  id: string | number;
  item: React.ReactNode;
};

type ListProps = Omit<ValidationListProps, 'list' | 'variant'> & {
  list: Array<ListItem>;
  variant: 'validation' | 'exclusion';
};

const List: React.FC<ListProps> = ({ variant, list }) => {
  const theme = useTheme();
  return (
    <MuiList aria-label="list">
      {list.map(({ id, item }) => (
        <MuiListItem
          disableGutters
          key={id}
          sx={{ alignItems: 'flex-start', paddingTop: '4px', paddingBottom: '4px' }}
        >
          <MuiListItemIcon sx={{ minWidth: '35px', paddingTop: '2px' }}>
            {variant === 'exclusion' ? (
              <Icon
                muiIcon={ClearIcon}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                color={theme.color.action.error}
              />
            ) : (
              <Icon
                muiIcon={CheckIcon}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                color={theme.color.action.success}
              />
            )}
          </MuiListItemIcon>
          {typeof item === 'string' ? (
            <Typography>{item}</Typography>
          ) : (
            <Box display="flex" flexDirection="column">
              {item}
            </Box>
          )}
        </MuiListItem>
      ))}
    </MuiList>
  );
};

export default List;
